import { keyframes } from '@emotion/react';
export const logomarkStroke = keyframes({
    '100%': {
        strokeDashoffset: 0,
    },
});
export const logomarkStartMask = keyframes({
    '0%, 6%': {
        clipPath: 'polygon(0% -12%, 0% -12%, 169% 63%, 169% 63%)',
    },
    '100%': {
        clipPath: 'polygon(0% -12%, 0% 308%, 169% 383%, 169% 63%)',
    },
});
export const logomarkEndMask = keyframes({
    '0%, 71%': {
        clipPath: 'polygon(0% 0%, 0% 78.5%, 100% 34.5%, 100% -44%)',
    },
    '96%, 100%': {
        clipPath: 'polygon(0% 0%, 0% 140%, 100% 96%, 100% -44%)',
    },
});
export const spinnerRotate = keyframes({
    '0%': {
        transform: 'rotate(0deg)',
    },
    '100%': {
        transform: 'rotate(360deg)',
    },
});
